import { useState, type ReactNode } from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { TriangleAlert } from "lucide-react";
import { Button } from "./Button.js";

export interface PopconfirmProps {
  title: ReactNode;
  description?: ReactNode;
  okText?: string;
  cancelText?: string;
  okType?: "primary" | "danger";
  placement?: "top" | "bottom" | "left" | "right";
  onConfirm?: () => void;
  onCancel?: () => void;
  children: ReactNode;
}

export function Popconfirm({
  title,
  description,
  okText,
  cancelText,
  okType = "primary",
  placement = "top",
  onConfirm,
  onCancel,
  children,
}: PopconfirmProps) {
  const [open, setOpen] = useState(false);
  return (
    <PopoverPrimitive.Root open={open} onOpenChange={setOpen}>
      <PopoverPrimitive.Trigger asChild>
        <span className="inline-flex">{children}</span>
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          side={placement}
          sideOffset={6}
          className="z-[1200] w-64 rounded-md border bg-popover p-3 text-popover-foreground shadow-md outline-none data-[state=closed]:animate-out data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95"
        >
          <div className="mb-3 flex gap-2">
            <TriangleAlert className="mt-0.5 size-4 shrink-0 text-[var(--az-warning-accent)]" />
            <div className="min-w-0">
              <div className="text-sm font-medium">{title}</div>
              {description != null && (
                <div className="mt-0.5 text-xs text-muted-foreground">{description}</div>
              )}
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button
              size="sm"
              variant="default"
              onClick={() => {
                setOpen(false);
                onCancel?.();
              }}
            >
              {cancelText ?? "İptal"}
            </Button>
            <Button
              size="sm"
              variant={okType === "danger" ? "danger" : "primary"}
              onClick={() => {
                setOpen(false);
                onConfirm?.();
              }}
            >
              {okText ?? "Tamam"}
            </Button>
          </div>
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
